import { ThunkDispatch } from "core-integration/src/store";
import { getElementControls } from "core-integration/src/store/elements/reducers";
import { updateElementControlsAndMaxCost } from "core-integration/src/store/elements/thunks";
import { IElementControls } from "core-integration/src/store/elements/types";
import { FilterChip } from "plos/src/components/Chip";
import { chipRowStyles } from "plos/src/components/FilterSheet/FilterChipRow/filterChipRow.css";
import { isKeyInType } from "plos/src/utils";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  NewsAddedSortByPopover,
  PlayerPopover,
  PricePopover,
} from "../../FilterPopovers";

export const DEFAULT_AVAILABILITY_FILTERS: Pick<
  IElementControls,
  "sort" | "filter" | "maxCost"
> = {
  sort: "news_added",
  filter: "all",
  maxCost: 150,
};

const ScoutAvailabilityFilters = () => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch<ThunkDispatch>();
  const controls = useSelector(getElementControls);

  const hasModifiedFilters = !Object.entries(
    DEFAULT_AVAILABILITY_FILTERS,
  ).every(([key, value]) => {
    if (isKeyInType(controls, key)) {
      return value === controls[key];
    }
    return false;
  });

  const handleResetFilters = () => {
    dispatch(
      updateElementControlsAndMaxCost({
        ...controls,
        ...DEFAULT_AVAILABILITY_FILTERS,
      }),
    );
  };

  return (
    <div className={chipRowStyles}>
      <PlayerPopover />
      <NewsAddedSortByPopover />
      <PricePopover />
      <FilterChip
        label={t("reset", "Reset")}
        onClick={handleResetFilters}
        isDisabled={!hasModifiedFilters}
        mode="reset"
      />
    </div>
  );
};

export default ScoutAvailabilityFilters;
